import React from 'react';
import { Stack, FormControl, FormLabel, TextField, Alert } from '@mui/material';

const Step0Form = ({ formData, handleChange }: { formData: any, handleChange: any }) => (
  <Stack spacing={2}>
    <FormControl>
      <FormLabel htmlFor="referal" sx={{ textAlign: 'left' }}>Referal</FormLabel>
      <TextField
        value={formData.referal}
        id="referal"
        name="referal"
        placeholder="Referal akan terisi otomatis"
        required
        fullWidth
        variant="outlined"
        InputProps={{
          readOnly: true,
        }}
        sx={{
          '& .MuiInputBase-input.Mui-readOnly': {
            cursor: 'not-allowed',
          },
        }}
      />
    </FormControl>

    <FormControl>
      <FormLabel htmlFor="name" sx={{ textAlign: 'left' }}>Nama Lengkap Pemesan</FormLabel>
      <TextField
        value={formData.name}
        onChange={handleChange}
        id="name"
        type="text"
        name="name"
        placeholder="Masukan Nama Lengkap"
        autoFocus
        required
        fullWidth
        variant="outlined"
      />
    </FormControl>
    <FormControl>
      <FormLabel htmlFor="phone" sx={{ textAlign: 'left' }}>No WA #1</FormLabel>
      <TextField
        value={formData.phone}
        onChange={handleChange}
        id="phone"
        type="text"
        name="phone"
        placeholder="Masukan Nomor Whatsapp Utama"
        required
        fullWidth
        variant="outlined"
      />
    </FormControl>
    <FormControl>
      <FormLabel htmlFor="phone2" sx={{ textAlign: 'left' }}>No WA #2</FormLabel>
      <TextField
        value={formData.phone2}
        onChange={handleChange}
        id="phone2"
        type="text"
        name="phone2"
        placeholder="Masukan Nomor Whatsapp Kedua"
        required
        fullWidth
        variant="outlined"
      />
    </FormControl>

    <FormControl>
      <FormLabel htmlFor="kecamatan" sx={{ textAlign: 'left' }}>Kecamatan</FormLabel>
      <TextField
        value={formData.kecamatan}
        onChange={handleChange}
        id="kecamatan"
        type="text"
        name="kecamatan"
        placeholder="Masukan Kecamatan"
        required
        fullWidth
        variant="outlined"
      />
    </FormControl>

    <FormControl>
      <FormLabel htmlFor="address" sx={{ textAlign: 'left' }}>Alamat Lengkap</FormLabel>
      <TextField
        value={formData.address}
        onChange={handleChange}
        id="outlined-multiline-static"
        name="address"
        placeholder="Masukan Alamat Lengkap"
        required
        fullWidth
        variant="outlined"
      />
    </FormControl>

    <FormControl>
      <FormLabel htmlFor="dateEvent" sx={{ textAlign: 'left' }}>Tanggal Acara</FormLabel>
      <TextField
        value={formData.dateEvent}
        onChange={handleChange}
        id="dateEvent"
        type="date"
        name="dateEvent"
        placeholder="Masukan Tanggal Acara"
        required
        fullWidth
        variant="outlined"
      />
      <Alert severity="info" sx={{ mt: 1 }}>
        <strong>Tanggal Acara</strong> bisa menyusul nanti.
      </Alert>

    </FormControl>

    <FormControl>
      <FormLabel htmlFor="timeEvent" sx={{ textAlign: 'left' }}>Jam Acara</FormLabel>
      <TextField
        value={formData.timeEvent}
        onChange={handleChange}
        id="timeEvent"
        name="timeEvent"
        placeholder="Masukan Jam Acara, Contoh : 4 Sore"
        required
        fullWidth
        variant="outlined"
      />
      <Alert severity="info" sx={{ mt: 1 }}>
        <strong>Contoh: 4 Sore.</strong> Jam Acara bisa menyusul nanti.
      </Alert>

    </FormControl>

    <FormControl>
      <FormLabel htmlFor="timeArrive" sx={{ textAlign: 'left' }}>Jam Paket Tiba</FormLabel>
      <TextField
        value={formData.timeArrive}
        onChange={handleChange}
        id="timeArrive"
        name="timeArrive"
        placeholder="Masukan Jam Paket Tiba, Contoh : 4 Sore"
        required
        fullWidth
        variant="outlined"
      />
      <Alert severity="info" sx={{ mt: 1 }}>
        <strong>Contoh: 4 Sore</strong> Jam paket tiba bisa menyusul nanti.
      </Alert>

    </FormControl>
  </Stack>
);

export default Step0Form;